/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseClient } from '../base-client';
import { DmsApiConfiguration } from '../dms-api-configuration';
import { DmsResponse } from '../dms-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DmsSaveTagRequest } from '../models/dms-save-tag-request';
import { DmsTagModel } from '../models/dms-tag-model';
import { DmsUpdateTagRequest } from '../models/dms-update-tag-request';

@Injectable({
  providedIn: 'root',
})
export class DmsTagsClient extends BaseClient {
  constructor(
    config: DmsApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createTag
   */
  static readonly CreateTagPath = '/api/Tags/{fullPath}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTag()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  createTag$Response(params: {
    fullPath: string;

    body?: DmsSaveTagRequest
  }): Observable<DmsResponse<DmsTagModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsTagsClient.CreateTagPath, 'post');
    if (params) {

      rb.path('fullPath', params.fullPath);

      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsTagModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTag$Response()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  createTag(params: {
    fullPath: string;

    body?: DmsSaveTagRequest
  }): Observable<DmsTagModel> {

    return this.createTag$Response(params).pipe(
      map((r: DmsResponse<DmsTagModel>) => r.body as DmsTagModel)
    );
  }

  /**
   * Path part for operation getTags
   */
  static readonly GetTagsPath = '/api/Tags/{pathFilter}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTags()` instead.
   *
   * This method doesn't expect any response body
   */
  getTags$Response(params: {
    pathFilter: string;

  }): Observable<DmsResponse<Array<DmsTagModel>>> {

    const rb = new RequestBuilder(this.rootUrl, DmsTagsClient.GetTagsPath, 'get');
    if (params) {

      rb.path('pathFilter', params.pathFilter);

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<Array<DmsTagModel>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTags$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  getTags(params: {
    pathFilter: string;

  }): Observable<Array<DmsTagModel>> {

    return this.getTags$Response(params).pipe(
      map((r: DmsResponse<Array<DmsTagModel>>) => r.body as Array<DmsTagModel>)
    );
  }

  /**
   * Path part for operation deleteTagsWithPath
   */
  static readonly DeleteTagsWithPathPath = '/api/Tags/{pathFilter}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTagsWithPath()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteTagsWithPath$Response(params: {
    pathFilter: string;

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsTagsClient.DeleteTagsWithPathPath, 'delete');
    if (params) {

      rb.path('pathFilter', params.pathFilter);

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteTagsWithPath$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteTagsWithPath(params: {
    pathFilter: string;

  }): Observable<void> {

    return this.deleteTagsWithPath$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getTag
   */
  static readonly GetTagPath = '/api/Tags/{tagId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTag()` instead.
   *
   * This method doesn't expect any response body
   */
  getTag$Response(params: {
    tagId: number;

  }): Observable<DmsResponse<DmsTagModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsTagsClient.GetTagPath, 'get');
    if (params) {

      rb.path('tagId', params.tagId);

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsTagModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTag$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  getTag(params: {
    tagId: number;

  }): Observable<DmsTagModel> {

    return this.getTag$Response(params).pipe(
      map((r: DmsResponse<DmsTagModel>) => r.body as DmsTagModel)
    );
  }

  /**
   * Path part for operation updateTag
   */
  static readonly UpdateTagPath = '/api/Tags/{tagId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTag()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  updateTag$Response(params: {
    tagId: number;

    body?: DmsUpdateTagRequest
  }): Observable<DmsResponse<DmsTagModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsTagsClient.UpdateTagPath, 'put');
    if (params) {

      rb.path('tagId', params.tagId);

      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsTagModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTag$Response()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  updateTag(params: {
    tagId: number;

    body?: DmsUpdateTagRequest
  }): Observable<DmsTagModel> {

    return this.updateTag$Response(params).pipe(
      map((r: DmsResponse<DmsTagModel>) => r.body as DmsTagModel)
    );
  }

  /**
   * Path part for operation deleteTag
   */
  static readonly DeleteTagPath = '/api/Tags/{tagId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTag()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteTag$Response(params: {
    tagId: number;

  }): Observable<DmsResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DmsTagsClient.DeleteTagPath, 'delete');
    if (params) {

      rb.path('tagId', params.tagId);

    }
    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as DmsResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteTag$Response()` instead.
   *
   * This method doesn't expect any response body
   */
  deleteTag(params: {
    tagId: number;

  }): Observable<void> {

    return this.deleteTag$Response(params).pipe(
      map((r: DmsResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation patchTag
   */
  static readonly PatchTagPath = '/api/Tags/{tagId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchTag()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  patchTag$Response(params: {
    tagId: number;

    body?: DmsUpdateTagRequest
  }): Observable<DmsResponse<DmsTagModel>> {

    const rb = new RequestBuilder(this.rootUrl, DmsTagsClient.PatchTagPath, 'patch');
    if (params) {

      rb.path('tagId', params.tagId);

      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as DmsResponse<DmsTagModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchTag$Response()` instead.
   *
   * This method sends `application/json` and handles response body of type `application/json`
   */
  patchTag(params: {
    tagId: number;

    body?: DmsUpdateTagRequest
  }): Observable<DmsTagModel> {

    return this.patchTag$Response(params).pipe(
      map((r: DmsResponse<DmsTagModel>) => r.body as DmsTagModel)
    );
  }

}
